import React from "react";
import { Tag } from "antd";
import { UserRole } from "../enums";

const RoleTag = ({ role }: { role: UserRole }) => {
  const roleAndColorEnum = {
    user: {
      color: "blue",
      display: "Club",
    },
    club: {
      color: "blue",
      display: "Club",
    },
    admin: {
      color: "red",
      display: "Admin",
    },
    legal: {
      color: "purple",
      display: "Legal Team",
    },
    archived_legacy: {
      color: "orange",
      display: "Archived",
    },
    archived: {
      color: "orange",
      display: "Archived",
    },
    external: {
      color: "grey",
      display: "External",
    },
  };

  const roleResult = roleAndColorEnum[role]
    ? roleAndColorEnum[role]
    : {
        color: "purple",
        display: "n/a",
      };

  return <Tag color={roleResult.color}>{roleResult.display}</Tag>;
};

export default RoleTag;
